import { DiscountLine } from "./DiscountLine";
import { HeaderLine } from "./HeaderLine";
import { RegularPriceLine } from "./RegularPriceLine";
import { SubtotalLine } from "./SubtotalLine";
import { TaxLine } from "./TaxLine";

export const InstallmentsLines = Object.assign(
  {},
  {
    DiscountLine,
    HeaderLine,
    RegularPriceLine,
    SubtotalLine,
    TaxLine,
  },
);
